import { useWindowDimensions, Platform } from 'react-native';

export default function useIsDesktop(): boolean {
  const { width } = useWindowDimensions();

  if (Platform.OS !== 'web') {
    return false;
  }

  return width >= 900;
}
